import { Component, Input } from '@angular/core';

@Component({
    selector: 'litmus-service-unavailable-modal',
    styleUrls: ['./litmus-service-unavailable-modal.style.scss'],
    templateUrl: './litmus-service-unavailable-modal.template.html',
    standalone: false
})
export class LitmusServiceUnavailable {
  @Input('litmusUnavailModalDesc') litmusUnavailModalDesc: string = 'SHARED.GENERIC_LTI.LITMUS_DOWN_MSG1';

  public imageBasePath: string = IMAGES_BASEPATH;
}